(() => {
  const baseUrl = window.location.origin;
  
  if (window.Shopify) {
    window.Shopify.routes = window.Shopify.routes || {};
    window.Shopify.routes.root = '/';
  }
  
  if (window.Abra?.config) window.Abra.config.baseUrl = baseUrl;
  window.addEventListener('abraLoaded', () => window.Abra?.config && (window.Abra.config.baseUrl = baseUrl));

  const getHandle = (href) => href?.split('/products/')[1]?.split('?')[0]?.split('/')[0];

  const applyToSection = (containerSelector, priceSelector = '.price') => {
    document.querySelectorAll(containerSelector).forEach(card => {
      const link = card.querySelector('a[href*="/products/"]');
      if (!link) return;

      const handle = getHandle(link.getAttribute('href'));
      if (!handle) return;

      card.setAttribute('data-product-handle', handle);
      card.setAttribute('data-abra-container', 'true');

      const price = card.querySelector(priceSelector);
      if (price) price.setAttribute('data-product-handle', handle);
    });
    
    setTimeout(() => window.Abra?.render && window.Abra.render(), 100);
  };

  const applyHandles = () => {
    const selectors = [
      { container: '.featured-collection__product-card', price: '.featured-collection__product-price' },
      { container: '.one-third.column.thumbnail', price: '.price' },
      { container: '.grid__item', price: '.price' },
      { container: '.product-card', price: '.price' },
      { container: '.card-wrapper', price: '.price' },
      { container: '[data-product-item]', price: '.price' },
      { container: '.quick-add-modal .product-item', price: '.price' },
      { container: '.predictive-search__item', price: '.price' },
      { container: '.cart-drawer__item', price: '.price' },
      { container: '.upsell-item', price: '.price' }
    ];

    selectors.forEach(({ container, price: priceSelector }) => {
      document.querySelectorAll(container).forEach(card => {
        const link = card.querySelector('a[href*="/products/"]');
        if (!link) return;

        const handle = getHandle(link.getAttribute('href'));
        if (!handle) return;

        card.setAttribute('data-product-handle', handle);
        card.setAttribute('data-abra-container', 'true');

        const price = card.querySelector(priceSelector);
        if (price) price.setAttribute('data-product-handle', handle);
      });
    });

    setTimeout(() => window.Abra?.render && window.Abra.render(), 100);
  };

   const separatePriceFromDays = () => {
     const btnText = document.querySelector('.cc-rc-plans-radios__submit-btn-text');
     if (!btnText) return;
     
     if (btnText.querySelector('.rc-price')) return;
     
     const text = btnText.textContent.trim();
     const match = text.match(/^(.*?)(\$[\d.,]+)(.*)$/);
     
     if (match) {
       const [, before, price, after] = match;
       btnText.innerHTML = `${before}<span class="rc-price" data-abra-selector=".rc-price">${price}</span>${after}`;
     }
   };
 
   const watchRechargeChanges = () => {
     const submitBtn = document.querySelector('.action_button.add_to_cart');
     if (!submitBtn) return;
     
     new MutationObserver(() => {
       setTimeout(separatePriceFromDays, 50);
     }).observe(submitBtn, { 
       childList: true, 
       characterData: true, 
       subtree: true 
     });
   };
 
  const updateUrlWithSellingPlan = (sellingPlanId) => {
    const url = new URL(window.location.href);
    
    if (sellingPlanId) {
      url.searchParams.set('selling_plan', sellingPlanId);
    } else {
      url.searchParams.delete('selling_plan');
    }
    
    window.history.replaceState({}, '', url.toString());
  };

  const getSellingPlanId = () => {
    const planDropdown = document.querySelector('[data-plans-dropdown]');
    if (planDropdown && planDropdown.value) {
      return planDropdown.value;
    }
    
    const selectedPlanRadio = document.querySelector('.cc-rc-plans-radios__input:checked');
    if (selectedPlanRadio && selectedPlanRadio.value) {
      return selectedPlanRadio.value;
    }
    
    return null;
  };

  const applyProductHandle = () => {
    const priceContainer = document.querySelector('.product .price__container');
    if (!priceContainer) return;
    
    // Pega o handle limpo da URL, removendo query parameters
    const pathname = window.location.pathname;
    const productHandle = pathname.split('/products/')[1]?.split('?')[0]?.split('/')[0];
    
    if (productHandle) {
      priceContainer.setAttribute('data-product-handle', productHandle);
    }
  };

  const setSellingPlanFlag = () => {
    const subsaveChecked = document.querySelector('[data-option-subsave] input:checked');
    const onetimeChecked = document.querySelector('[data-option-onetime] input:checked');
    
    if (window.Abra) {
      if (subsaveChecked) {
        window.Abra.useSellingPlanPriceOnProductBlock = true;
        const sellingPlanId = getSellingPlanId();
        updateUrlWithSellingPlan(sellingPlanId);
      } else if (onetimeChecked) {
        window.Abra.useSellingPlanPriceOnProductBlock = false;
        updateUrlWithSellingPlan(null);
      }
    }
    
    applyProductHandle();
  };
 
   const addRechargeClickListeners = () => {
     document.querySelectorAll('[data-option-subsave]').forEach(option => {
       const input = option.querySelector('input[type="radio"]');
       if (input) {
         input.addEventListener('change', () => {
           if (input.checked) {
             setTimeout(() => {
               if (window.Abra) window.Abra.useSellingPlanPriceOnProductBlock = true;
               const sellingPlanId = getSellingPlanId();
               updateUrlWithSellingPlan(sellingPlanId);
               applyProductHandle();
               separatePriceFromDays();
               window.Abra?.render && window.Abra.render();
             }, 100);
           }
         });
       }
     });
     
     document.querySelectorAll('[data-option-onetime]').forEach(option => {
       const input = option.querySelector('input[type="radio"]');
       if (input) {
         input.addEventListener('change', () => {
           if (input.checked) {
             setTimeout(() => {
               if (window.Abra) window.Abra.useSellingPlanPriceOnProductBlock = false;
               updateUrlWithSellingPlan(null);
               applyProductHandle();
               separatePriceFromDays();
               window.Abra?.render && window.Abra.render();
             }, 100);
           }
         });
       }
     });
     
     const planDropdown = document.querySelector('[data-plans-dropdown]');
     if (planDropdown) {
       planDropdown.addEventListener('change', () => {
         setTimeout(() => {
           if (window.Abra) window.Abra.useSellingPlanPriceOnProductBlock = true;
           const sellingPlanId = getSellingPlanId();
           updateUrlWithSellingPlan(sellingPlanId);
           applyProductHandle();
           separatePriceFromDays();
           window.Abra?.render && window.Abra.render();
         }, 100);
       });
     }
   };
 
  const watchForPlanRadios = () => {
    const handlePlanChange = (e) => {
      if (e.target && e.target.classList.contains('cc-rc-plans-radios__input')) {
        if (window.Abra) {
          window.Abra.useSellingPlanPriceOnProductBlock = true;
        }
        setTimeout(() => {
          const sellingPlanId = getSellingPlanId();
          updateUrlWithSellingPlan(sellingPlanId);
          applyProductHandle();
          if (window.Abra?.render) {
            window.Abra.render();
          }
        }, 200);
      }
    };
    
    document.addEventListener('change', handlePlanChange, true);
    document.addEventListener('click', handlePlanChange, true);
  };

   const renderOnRechargeWidget = () => {
     new MutationObserver((mutations, observer) => {
       if (document.querySelector('.rc-container-wrapper')) {
         setSellingPlanFlag();
         applyProductHandle();
         separatePriceFromDays();
         watchRechargeChanges();
         addRechargeClickListeners();
         watchForPlanRadios();
         setTimeout(() => window.Abra?.render && window.Abra.render(), 500);
         observer.disconnect();
       }
     }).observe(document.body, { childList: true, subtree: true });
   };
 
  const init = () => {
    applyHandles();
    applyProductHandle();
    if (!window.Abra?.render) setTimeout(() => window.Abra?.render && window.Abra.render(), 1500);
    renderOnRechargeWidget();
    watchForPlanRadios();
  };

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();

  const watchSelectors = '.featured-collection__product-card, .one-third.column.thumbnail, .grid__item, .product-card, .card-wrapper, [data-product-item], .quick-add-modal, .predictive-search__item, .cart-drawer__item, .upsell-item';
  
  new MutationObserver(mutations => {
    mutations.some(m => Array.from(m.addedNodes).some(n => 
      n.nodeType === 1 && n.matches?.(watchSelectors)
    )) && setTimeout(applyHandles, 100);
  }).observe(document.body, { childList: true, subtree: true });

  window.AbraEmuaid = { applyToSection, applyHandles, getHandle };
})();